import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { IInterval } from '../../../models/call-history-filter.models';

@Component({
  selector: 'app-filter-interval',
  templateUrl: './filter-interval.component.html',
  styleUrls: ['./filter-interval.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterIntervalComponent),
      multi: true,
    },
  ],
})
export class FilterIntervalComponent implements ControlValueAccessor {
  @Input() unit: string;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: any = () => {};
  public value: IInterval = {
    from: null,
    to: null,
  };

  public onChangeFromValue(event: InputEvent) {
    this.value.from = Number(event.target['value']);
    if (Number.isNaN(this.value.from)) {
      this.onChange(null);
    } else {
      this.onChange(this.value);
    }
  }

  public onChangeToValue(event: InputEvent) {
    this.value.to = Number(event.target['value']);
    if (Number.isNaN(this.value.to) || this.value.to === 0) {
      this.onChange(null);
    } else {
      this.onChange(this.value);
    }
  }

  writeValue(obj: IInterval): void {
    if (obj) {
      this.value = obj;
      this.onChange(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
